/** @jsxImportSource @emotion/react */
import { Button, YoutubeButton } from 'components/landing/ui';
import { arrowRight, play } from 'components/landing/ui/icons';
import { Link as RouterLink } from 'react-router-dom';

import autofollow1x from '../../../images/modules/autofollow.png';
import autofollow2x from '../../../images/modules/autofollow@2x.png';
import autofollow3x from '../../../images/modules/autofollow@3x.png';
import autolike1x from '../../../images/modules/autolike.png';
import autolike2x from '../../../images/modules/autolike@2x.png';
import autolike3x from '../../../images/modules/autolike@3x.png';
import clerk1x from '../../../images/modules/clerk.png';
import clerk2x from '../../../images/modules/clerk@2x.png';
import clerk3x from '../../../images/modules/clerk@3x.png';
import congrats1x from '../../../images/modules/congrats.png';
import congrats2x from '../../../images/modules/congrats@2x.png';
import congrats3x from '../../../images/modules/congrats@3x.png';

export const sets = {
  congrats: `${congrats1x} 1x, ${congrats2x} 2x, ${congrats3x} 3x`,
  autolike: `${autolike1x} 1x, ${autolike2x} 2x, ${autolike3x} 3x`,
  clerk: `${clerk1x} 1x, ${clerk2x} 2x, ${clerk3x} 3x`,
  autofollow: `${autofollow1x} 1x, ${autofollow2x} 2x, ${autofollow3x} 3x`,
};

const Screenshot = ({ currentModuleId, openVideoGallery }) => {
  const set = sets[currentModuleId];

  const handlePlayClick = () => openVideoGallery(currentModuleId);

  return (
    <div
      css={{
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        maxWidth: 456,
        alignSelf: 'center',
        marginBottom: 30,
        '@media (min-width:992px)': { maxWidth: 'unset', alignSelf: 'unset', marginBottom: 0 },
      }}
    >
      <div css={{ justifyContent: 'center', width: '100%', marginBottom: 10 }}>
        <img srcSet={set} css={{ width: '100%', maxWidth: 527 }} />
      </div>

      <YoutubeButton
        css={{
          position: 'absolute',
          left: 'calc(50% - 64px/2)',
          top: 'calc(38% - 46px/2)',
        }}
        onClick={handlePlayClick}
      />

      <div
        css={{
          width: '100%',
          flexDirection: 'column',
          '@media (min-width:1366px)': { flexDirection: 'row' },
        }}
      >
        <Button
          type="black"
          icon={play}
          css={{
            flexBasis: '50%',
            flexShrink: 1,
            marginBottom: 30,
            '@media (min-width:1366px)': { marginBottom: 0, marginRight: 30 },
          }}
          onClick={handlePlayClick}
        >
          Видео обзор
        </Button>

        {/* <RouterLink to="/lk" target="_blank" css={{ flexBasis: '50%', flexShrink: 1 }}>
        </RouterLink> */}
        <Button
          onClick={() => window.open('https://vk-boss-light.web.app/guide', '_blank')}
          type="blue"
          icon={arrowRight}
          css={{ width: '100%', padding: `5px 15px` }}
        >
          Попробовать бесплатно
        </Button>
      </div>
    </div>
  );
};

export default Screenshot;
